import { API_CONFIG } from '@/lib/config';

export const API_BASE_URL = API_CONFIG.BASE_URL;

export const AUTH_ENDPOINTS = {
  SIGN_UP: '/user/auth/register/',
  SIGN_IN: '/auth/login/',
  FORGOT_PASSWORD: '/auth/user/forgot_password/',
  VERIFY_OTP: '/auth/user/verify_otp/',
  SET_PASSWORD: '/auth/user/set_password/',
  CHANGE_PASSWORD: '/auth/user/set_password_authenticated/',
  VERIFY_EMAIL: '/auth/verify-email',
  REFRESH_TOKEN: '/auth/refresh/',
  LOGOUT: '/auth/logout/',
  CSRF: '/auth/csrf/',
} as const;

export const USER_ENDPOINTS = {
  ME: '/user/me/',
  UPDATE_USER: (userId: string) => `/user/${userId}/`,
  ACCEPT_TERMS: '/user/accept-terms/',
} as const;

export const SCHOOL_ENDPOINTS = {
  BASE: '/schools',
  GET_ALL: '/schools',
  GET_BY_ID: (id: string) => `/schools/${id}`,
  CREATE: '/schools',
  UPDATE: (id: string) => `/schools/${id}`,
  DELETE: (id: string) => `/schools/${id}`,
} as const;

export const EXAM_ENDPOINTS = {
  BASE: '/exams/',
  GET_ALL: '/exams/',
  GET_BY_ID: (id: string) => `/exams/${id}/`,
  GET_BY_SCHOOL: (schoolId: string) => `/exams?school=${schoolId}`,
  REPORT_ISSUE: (id: string) => `/exams/${id}/report_issue/`,
  PROCTOR_EXAMS: '/exams/proctor_exams',
} as const;

export const EXAM_TYPE_ENDPOINTS = {
  BASE: '/exam_types/',
  GET_ALL: '/exam_types/',
  GET_BY_ID: (id: string) => `/exam_types/${id}`,
} as const;

export const EXAM_SESSION_ENDPOINTS = {
  BASE: '/exam_sessions/',
  CREATE: '/exam_sessions/',
  GET_BY_ID: (id: number) => `/exam_sessions/${id}`,
  UPDATE: (id: number) => `/exam_sessions/${id}/`,
  CHECK_ACTIVE_SESSION: (examId: string | number) => `/exam_sessions/check_active_session/?exam_id=${examId}`,
  START_SESSION: '/exam_sessions/start_session/',
  COMPLETE_SESSION: (sessionId: number) => `/exam_sessions/${sessionId}/complete_session/`,
  GET_SUBJECT_PERFORMANCE: (sessionId: string | number) => `/exam_sessions/${sessionId}/subject_performance/`,
  GET_OPENAI_REPORT: (sessionId: string | number) => `/exam_sessions/${sessionId}/openai_student_performance_report/`,
} as const;

export const QUESTION_ENDPOINTS = {
  BASE: '/questions/',
  GET_ALL: '/questions/',
  GET_BY_ID: (id: string) => `/questions/?id=${id}`,
  GET_BY_EXAM: (examId: string) => `/questions/?exam_id=${examId}`,
  REFRESH_IMAGE_URLS: (id: string) => `/questions/${id}/refresh_image_urls/`,
} as const;

export const ANSWER_ENDPOINTS = {
  BASE: '/answers/',
  CREATE: '/answers/',
  GET_BY_ID: (id: string) => `/answers?id=${id}`,
  GET_BY_SESSION: (sessionId: string) => `/answers?session_id=${sessionId}`,
  UPDATE: (id: number) => `/answers/${id}/`,
} as const;

export const PRINCIPAL_DASHBOARD_ENDPOINTS = {
  DASHBOARD_STATS: '/principal_dashboard/dashboard_stats/',
  SECTIONS: '/principal_dashboard/sections/',
  SECTION_PERFORMANCE: '/principal_dashboard/section_performance/',
  CLASS_LIST: '/principal_dashboard/class_list/',
  PERFORMANCE_SUBJECT_RANKING: '/principal_dashboard/performance_subject_ranking/',
  PERFORMANCE_STUDENT_RANKING: '/principal_dashboard/performance_student_ranking/',
  BATCHES: '/principal_dashboard/batches/',
  EXAMS: '/principal_dashboard/exams/',
  EXAM_OVERVIEW: '/principal_dashboard/exam_overview/',
  SUBJECT_PERFORMANCE: '/principal_dashboard/subject_performance/',
  SECTION_STUDENTS: '/principal_dashboard/section_students/',
  BATCH_ANALYTICS: '/principal_dashboard/batch_analytics/',
  GENERATE_BATCH_ANALYTICS: '/principal_dashboard/openai_batch_performance_report/',
} as const;

export const PROCTOR_DASHBOARD_ENDPOINTS = {
  DASHBOARD: '/proctor/dashboard/',
  DASHBOARD_STATS: '/proctor/dashboard-stats/',
} as const;

export const REVIEWER_ENDPOINTS = {
  BASE: '/reviewers/',
  GET_ALL: '/reviewers/',
  GET_BY_ID: (id: number) => `/reviewers/${id}/`,
  GET_PROGRESS: (id: number) => `/reviewers/${id}/progress/`,
  UPDATE_PROGRESS: (id: number) => `/reviewers/${id}/update_progress/`,
  CREATE: '/reviewers/',
  UPDATE: (id: number) => `/reviewers/${id}/`,
  DELETE: (id: number) => `/reviewers/${id}/`,
} as const;

export const GRADING_ENDPOINTS = {
  GET_SESSIONS_FOR_GRADING: '/grading/sessions/',
  GET_SESSION_DETAILS: (sessionId: number) => `/grading/sessions/${sessionId}/`,
  SUBMIT_GRADE: (answerId: number) => `/grading/answers/${answerId}/grade/`,
  GET_ANSWER_GRADE: (answerId: number) => `/grading/answers/${answerId}/`,
} as const;

export const CET_READINESS_ENDPOINTS = {
  LEARNING_STREAMS: '/cet_readiness/learning_streams/',
  MY_READINESS: '/cet_readiness/my_readiness/',
} as const;